/**
 * Pagos de Ventas Generales — pantalla unificada de cobro y mantenimiento.
 *
 * La vista principal es el mantenimiento de pagos embebido (ares9640:
 * listado por fechas, anular pagos — devuelve el saldo a la venta — y
 * reimprimir). La tarjeta "Cobrar venta" (ares9650) abre el formulario de
 * cobro en diálogo a pantalla completa; al guardar, el listado se recarga.
 *
 * Sustituye las entradas de menú de pagosventasgenerales.js y
 * mantenimientopagosventas.js; ambos componentes se reutilizan.
 */
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import { useMaterialUIController } from "context";
import { FP, PageHeader, ActionCard } from "components/financepro";
import { tienePermisosModulo } from "lib/seguridad/permisosPorModulo";
import PagosVentasGenerales from "modules/ventasgenerales/pagosventasgenerales";
import MantenimientoPagosVentas from "modules/ventasgenerales/mantenimientopagosventas";
import useAccionInicial from "lib/useAccionInicial";

export default function PagosVentasUnificado() {
  const [controller] = useMaterialUIController();
  const { roleDetalles } = controller;

  // Permisos por programa ARES (el backend re-valida en permisos.py).
  const puedeCobrar = tienePermisosModulo(roleDetalles, "ares9650");
  const puedeMantenimiento = tienePermisosModulo(roleDetalles, "ares9640");

  const [cobroOpen, setCobroOpen] = useState(false);

  // Enlace profundo desde el buscador global (?accion=...).
  useAccionInicial({
    cobrar: { permitido: puedeCobrar, abrir: () => setCobroOpen(true) },
  });

  // Incrementarlo recarga el listado embebido (tras aplicar un cobro).
  const [refreshKey, setRefreshKey] = useState(0);
  const refrescar = () => setRefreshKey((k) => k + 1);

  return (
    <Box component="main" sx={{ minHeight: "100vh", bgcolor: FP.color.surface }}>
      <PageHeader
        title="Pagos de Ventas Generales"
        subtitle="Cobra las ventas pendientes y gestiona los pagos aplicados en un solo lugar"
      />

      <Box sx={{ p: { xs: 2, md: 3 } }}>
        {puedeCobrar && (
          <Grid container spacing={2.5} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <ActionCard
                icon={PaymentsOutlinedIcon}
                titulo="Cobrar venta"
                descripcion="Aplica cobros a las ventas generales pendientes"
                color={FP.color.success}
                onClick={() => setCobroOpen(true)}
              />
            </Grid>
          </Grid>
        )}

        {/* Vista principal: mantenimiento de pagos (anular/reimprimir) */}
        {puedeMantenimiento && <MantenimientoPagosVentas embedded refreshToken={refreshKey} />}
      </Box>

      {/* Cobrar venta general (formulario completo a pantalla completa) */}
      <Dialog fullScreen open={cobroOpen} onClose={() => setCobroOpen(false)}>
        <PagosVentasGenerales embedded onExit={() => { setCobroOpen(false); refrescar(); }} onSaved={refrescar} />
      </Dialog>
    </Box>
  );
}
